import { fallbackValue } from "constants/fallbackConstant";

const formatPhoneNumber = (number) => {
    if (!number) return fallbackValue; // Ensure fallback for missing numbers
    return number.replace(/^00962_/, "0"); // Replace Jordan country code format
  };

  export default formatPhoneNumber;